{
    "Umyndig.Pageheading.Engangsstonad": "Søknad om engangsstønad",
    "Umyndig.Pageheading.Foreldrepenger": "Søknad om foreldrepenger",
    "Umyndig.Pageheading.Svangerskapspenger": "Søknad om svangerskapspenger",
    "Umyndig.Tittel": "Fordi du er under 18 år, må du sende papirsøknad",
    "Umyndig.Tekst": "Fordi du er under 18 år, må en av foreldrene dine eller en foresatt skrive under på søknaden din sammen med deg. Derfor må du fylle ut søknaden på papir og sende den i posten til Nav.",
    "Umyndig.Knapp.Papirsøknad": "Gå til papirsøknaden",
    "ErrorSummaryFelles.Tittel": "Du må rette opp i følgende feil:",
    "StepButtons.Forrige": "Forrige steg",
    "StepButtons.ForrigeSimple": "Forrige",
    "StepButtons.Neste": "Neste steg",
    "StepButtons.NesteSimple": "Neste",
    "StepButtons.Send": "Send søknaden",
    "StepButtons.GåTilOppsummering": "Gå til oppsummering",
    "StepButtons.GåTilOppsummeringSimple": "Oppsummering",
    "ErrorPage.Engangsstønad": "Engangsstønad",
    "ErrorPage.Foreldrepenger": "Foreldrepenger",
    "ErrorPage.Svangerskapspenger": "Svangerskapspenger",
    "ErrorPage.Heading": "Beklager, noe har gått galt med søknaden din på grunn av en teknisk feil hos oss",
    "ErrorPage.Message": "Du kan vente litt og deretter prøve å søke på nytt. Dersom det fortsatt er problemer kan du kontakte brukerstøtte for å få hjelp.",
    "ErrorPage.Contact": "Kontakt brukerstøtte",
    "ErrorPage.TryAgain": "Søk på nytt",
    "ErrorPage.ErrorMessage": "Feilmelding",
    "ScanDocumentInfo.Tittel": "Hvordan ta bilde av et dokument med mobilen",
    "ScanDocumentInfo.Del1": "Har du et dokument på papir, kan du ta et bilde av dokumentet for å sende det til oss.",
    "ScanDocumentInfo.Liste.Punkt1": "Ta bilde av dokumentet med smarttelefonen eller nettbrettet.",
    "ScanDocumentInfo.Liste.Punkt2": "Sjekk at dokumentet er lett å lese.",
    "ScanDocumentInfo.Liste.Punkt3": "Logg inn på nav.no via mobilen – last opp og legg bildene ved den elektroniske søknaden.",
    "ScanDocumentInfo.Liste.Punkt4": "Ønsker du å bruke PC eller Mac, kan du sende bildene til din private e-postkonto og lagre bildene på enheten din.",
    "ScanDocumentInfo.Liste.Punkt5": "Last opp og legg bildene ved den elektroniske søknaden din.",
    "ScanDocumentInfo.Del2": "Har du skanner, kan du skanne dokumenter.",
    "ScanDocumentInfo.Link": "Mer informasjon om å sende vedlegg på nav.no.",
    "StepFooter.Avslutt": "Slett søknaden",
    "StepFooter.ContinueLater": "Fortsett senere",
    "AvsluttModal.Tittel": "Avslutt",
    "AvsluttModal.Info": "Søknaden din slettes. Hvis du skal søke senere, må du fylle ut fra starten.",
    "AvsluttModal.Cancel": "Avbryt",
    "AvsluttModal.Delete": "Slett søknaden",
    "FortsettSenereModal.Tittel": "Fortsett senere",
    "FortsettSenereModal.Info": "Søknaden er lagret, og du kan fullføre den senere. Søknaden blir lagret i en uke.",
    "FortsettSenereModal.Ok": "Ok",
    "SimpleErrorPage.ErrorHeader": "Beklager, det ser ut som at noe har gått galt på grunn av en teknisk feil hos Nav",
    "SimpleErrorPage.ErrorBody": "Du kan prøve å planlegge på nytt, og dersom du fortsatt får en feil kan du vente litt og komme tilbake senere.",
    "SimpleErrorPage.TryAgain": "Planlegg på nytt",
    "Step.HarValgfrieFelt": "Alle felt må fylles ut, unntatt felt markert med (valgfritt).",
    "Step.HarObligatoriskeFelt": "Alle felt må fylles ut.",
    "FrontPage.Start": "Start",
    "RegisterdataUtdatert.Engangsstønad": "Engangsstønad",
    "RegisterdataUtdatert.Foreldrepenger": "Foreldrepenger",
    "RegisterdataUtdatert.Svangerskapspenger": "Svangerskapspenger",
    "RegisterdataUtdatert.StartPaNytt": "Start på nytt",
    "RegisterdataUtdatert.Heading": "Opplysninger er endret",
    "RegisterdataUtdatert.Message": "Opplysninger om deg er endret siden sist du fylte ut søknaden. Du må derfor starte utfyllingen av søknaden på nytt.",
    "ProgressStepper.ShowSteps": "Vis alle steg",
    "ProgressStepper.HideSteps": "Skjul alle steg",
    "ProgressStepper.StepCounter": "Steg {activeStep} av {totalSteps}",
    "DekningsgradUtbetalingEksempel.Tittel": "Begge alternativene gir omtrent like mye penger totalt",
    "DekningsgradUtbetalingEksempel.Intro": "Eksemplet under bruker en månedslønn på 50 000 kr.",
    "DekningsgradUtbetalingEksempel.Rad.Varighet": "Varighet:",
    "DekningsgradUtbetalingEksempel.Rad.PerMåned": "Per måned:",
    "DekningsgradUtbetalingEksempel.Rad.Totalt": "Totalt ca.:",
    "DekningsgradUtbetalingEksempel.Hundre.Tittel": "100 % utbetaling",
    "DekningsgradUtbetalingEksempel.Hundre.Varighet": "49 uker",
    "DekningsgradUtbetalingEksempel.Hundre.PerMåned": "50 000 kr",
    "DekningsgradUtbetalingEksempel.Hundre.Totalt": "565 460 kr",
    "DekningsgradUtbetalingEksempel.Atti.Tittel": "80 % utbetaling",
    "DekningsgradUtbetalingEksempel.Atti.Varighet": "61 uker + 1 dag",
    "DekningsgradUtbetalingEksempel.Atti.PerMåned": "40 000 kr",
    "DekningsgradUtbetalingEksempel.Atti.Totalt": "564 876 kr",
    "DekningsgradUtbetalingEksempel.Fotnote": "Med denne lønnen er forskjellen 584 kroner. Feriepengene er også tilnærmet lik for begge alternativene.",
    "DekningsgradUtbetalingEksempel.Link": "Beregn hvor mye du kan få på nav.no"
}
